import { useState } from 'react';
import { Link } from 'react-router-dom'
import "../global"
import './Form.css'

function Register() {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
    const [response, setResponse] = useState('')


    const onSubmit = async (e) => {
        e.preventDefault()

        const data = await fetch(global.API_BASE + '/user/register', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name: name,
                email: email,
                password: pass
            })
        }).then(res => res.json())
        setResponse(data.message || "Something went wrong")
        if (data.token != null) {
          localStorage.setItem('token', data.token)
          localStorage.setItem('name', data.name)
          window.location.reload()
        }
    }

    return (
        <div className='form-container'>
            <h1 className='form-header'>Register</h1>
            <div className='link-container'><Link to='/' replace='true'>Already have an account?</Link></div>
            <form className='form'>
                <label>Name:</label>
                <input type="name" className='text-field' onChange={e => setName(e.target.value)} />
                <label>Email:</label>
                <input type="email" className='text-field' onChange={e => setEmail(e.target.value)} />
                <label>Password:</label>
                <input type="password" className='text-field' onChange={e => setPass(e.target.value)} autoComplete='off' />
                <br />
                <div className='submit-btn' onClick={onSubmit}>Submit</div>
                <label className='response-text'>{response}</label>
            </form>
        </div>
    );
  }

export default Register;
  